import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export function RouteAnnouncer() {
  const { pathname } = useLocation();
  const [message, setMessage] = useState("");

  useEffect(() => {
    const timer = setTimeout(() => {
      const pageTitle = document.title.replace(/ \| Creativorare$/, "");
      setMessage(`Navigated to ${pageTitle}`);
    }, 150);

    return () => clearTimeout(timer);
  }, [pathname]);

  return (
    <div
      role="status"
      aria-live="polite"
      aria-atomic="true"
      className="sr-only"
    >
      {message}
    </div>
  );
}
